<!--
 * @Description: 上传附件
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-06-25 13:42:08
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2025-06-11 17:52:49
-->
<template>
  <div class="cloud-page-com">
    <div :class="['cloud-item-list', displayOneLine ? 'file-whole-line' : '']">
      <jw-upload :show-upload-button="fieldExt?.fileType == '2' && fieldExt?.uploadType == '2' ? false : { showOnExceedLimit: true }" :class="data.fileList.length < limit ? 'upload-list' : 'upload-list-min'" list-type="picture" :image-preview="true" :limit="limit" :disabled="disabled" :accept="accept" :action="data.actionUrl" name="file" multiple :headers="data.headers" ref="uploadRef" @change="uploadChange" :default-file-list="data.fileList" @before-upload="beforeUpload" @exceed-limit="exceedLimit" :show-retry-button="false" :show-remove-button="showRemoveBtn" :tip="acceptTips()">
        <template #image="{ fileItem }">
          <template v-if="tools.checkFileExt(fileItem.name, 'img')">
            <jw-image class="hand" width="100%" fit="cover" :src="fileItem?.response?.data?.[0]?.url || fileItem?.url" />
          </template>
          <span class="file-preview video-cover hand" v-else-if="tools.checkFileExt(fileItem.name, 'video')">
            <img class="" style="object-fit: cover" :src="`${fileItem?.response?.data?.[0]?.url || fileItem?.url}?x-oss-process=video/snapshot,t_1000,f_jpg,w_900,m_fast`" />
          </span>
          <template v-else>
            <jw-link :href="fileItem?.response?.data?.[0]?.url || fileItem?.url" target="_blank" class="download_a">
              <span class="file-preview" v-if="tools.checkFileExt(fileItem.name, 'pdf')">
                <qf-icon-pdf width="24px" height="24px" />
              </span>
              <span class="file-preview" v-else-if="tools.checkFileExt(fileItem.name, 'xlsx')">
                <qf-icon-excel width="24px" height="24px" />
              </span>
              <span class="file-preview" v-else-if="tools.checkFileExt(fileItem.name, 'docs')">
                <qf-icon-word width="24px" height="24px" />
              </span>
              <span class="file-preview" v-else-if="tools.checkFileExt(fileItem.name, 'zip')">
                <qf-icon-zip width="24px" height="24px" />
              </span>
              <span class="file-preview" v-else>
                <qf-icon-file width="24px" height="24px" />
              </span>
            </jw-link>
          </template>
        </template>
        <!-- 文件名称 (这一步其实是没有用的啊)-->
        <template #file-name="{ fileItem }">
          <jw-link :title="fileItem.name" :href="fileItem?.response?.data?.[0]?.url || fileItem?.url" target="_blank">{{ fileItem.name }}</jw-link>
        </template>
        <template #extra-button="{ fileItem }">
          <div class="progress-con">
            <jw-progress :percent="filterPercent(fileItem)" :style="{ width: '100%' }" stroke-width="2" :show-text="false" />
            <div v-if="fileItem.status != 'error'" class="progress-tips">{{ filterPercent(fileItem) == 1 ? '上传完成' : '上传中' }}</div>
          </div>
        </template>
      </jw-upload>
      <!-- <jw-tooltip :content="accept && accept != 0 ? $t('支持上传') + `${accept}` + $t('格式的文件') : $t('文件类型无限制')" v-if="data.fileList.length < limit">
        <p class="tips-text">{{ accept && accept != 0 ? $t('支持上传') + `${accept}` + $t('格式的文件') : $t('文件类型无限制') }}</p>
      </jw-tooltip> -->
      <!-- {{ data.fileList }} -->
    </div>
  </div>
</template>
<script setup>
import { reactive, ref, watchEffect } from 'vue';
import { Message } from '@arco-design/web-vue';
import { getToken } from '@/utils/auth';
import { useI18n } from 'vue-i18n';
import { tools } from '@/utils/tools';
const { t } = useI18n();
// import { opportunityService } from '@/api/';
const emits = defineEmits(['cb']);
const props = defineProps({
  accept: {
    //接收的上传文件类型
    type: String
  },
  limit: {
    //限制上传文件的数量。0表示不限制
    type: Number,
    default: 0
  },
  defaultFileList: {
    //默认的上传文件
    type: Array
  },
  disabled: {
    //是否禁用
    type: Boolean,
    default: false
  },
  showRemoveBtn: {
    //是否显示删除按钮
    type: Boolean,
    default: true
  },
  displayOneLine: {
    //是否展示整行
    type: Boolean,
    default: false
  },
  fieldExt: {
    type: [Object, String],
    default: () => {}
  }
});
console.log(props);
const filterPercent = (item) => {
  if (item.percent < 0.9 || item.percent == 0.9) {
    return item.percent;
  } else if (item.percent > 0.9 && item.status != 'done') {
    return 0.9;
  } else {
    return 1;
  }
};
const token = getToken() || null;
const uploadRef = ref();
const data = reactive({
  headers: {
    authorization: `Bearer ${token}`
  },
  // id: inject('detailParams').id, //id,
  // type: inject('detailParams').entity,
  actionUrl: '/api/uploadFile',
  fileList: []
});
watchEffect(() => {
  data.fileList = props?.defaultFileList || [];
});

//支持上传的文件类型
const acceptTips = () => {
  const getAccept = props?.accept;
  const uniqueLowercaseAccept = [...new Set(getAccept?.map((ext) => ext.toLowerCase()))].join(',');
  const tipString = props?.accept && props.accept != 0 ? t('支持上传') + `${uniqueLowercaseAccept}` + t('格式的文件') : t('文件类型无限制');
  return `${tipString}` + ',' + t('最多上传') + `${props.limit}` + t('个文件');
};
//超出限制数量后校验
const exceedLimit = (fileList, files) => {
  console.log('file上传前数量限制', fileList, files);
  //   console.log('limit', props.limit);
  //   console.log('files', data.fileList.length);
  if (Number(files.length + data.fileList.length) > props.limit) {
    Message.error(t('单次上传最多支持') + `${props.limit}` + t('个文件'));
    return false;
  }
};

// 上传前效验文件大小
const beforeUpload = (file) => {
  console.log('file上传前', file);

  const name = file.name;
  const namelist = [];
  data.fileList?.map((el) => namelist.push(el.name));
  console.log(namelist);
  // const fileType = name.split('.')[1];
  const fileTypeArray = name.split('.');
  const fileType = fileTypeArray.length > 0 && fileTypeArray[fileTypeArray.length - 1]; // 文件类型
  // console.log('文件类型', fileType);
  const typeList = props.accept;
  if (typeList.includes('png')) typeList.push('PNG');
  if (typeList.includes('jpg')) typeList.push('JPG');
  if (typeList.includes('jpeg')) typeList.push('JPEG');
  if (typeList.includes('gif')) typeList.push('GIF');
  if (typeList.includes('webp')) typeList.push('WEBP');
  if (props.limit > 0 && namelist.length >= props.limit) {
    Message.error(t('单次上传最多支持') + `${props.limit}` + t('个文件'));
    return false;
  }
  if (typeList && typeList != 0 && typeList.indexOf(fileType) == -1) {
    Message.error(t('上传失败,请上传支持的文件类型'));
    return false;
  }
  if (namelist.indexOf(name) > -1) {
    Message.error(t('文件已存在，无需重复上传'));
    return false;
  }
  if (file.size / 1024 / 1024 >= 300) {
    Message.error(t('上传失败,文件大小不能超过300M'));
    return false;
  }
  return true;
};
const uploadChange = (fileList, fileItem) => {
  // console.log(110, fileList);
  // console.log(1101, fileItem);
  data.fileList = fileList;
  if ((fileItem?.response?.msg && fileItem?.response?.code != 0) || fileItem?.status == 'error') {
    fileItem?.status !== 'error' && Message.error(fileItem?.response?.msg);
    if (data.fileList?.length > 0 && fileItem) {
      const _findIndex = data.fileList?.findIndex((el) => el?.uid == fileItem?.uid);
      if (_findIndex > -1) {
        //兼容组件报错返回的fileList不包含fileItem的情况
        data.fileList[_findIndex].status = 'error';
        data.fileList[_findIndex].response = '';
      }
    }
  }
  console.log('data.fileList', data.fileList);
  emits('cb', data.fileList);
};
</script>
<style scoped lang="less">
@import './xl-upload.less';
</style>
<style>
.cloud-modal .arco-modal-body {
  height: 400px;
  overflow: hidden;
  overflow-y: scroll;
}
</style>
